var DisplayFormatParser = /** @class */ (function () {
    function DisplayFormatParser() {
        this.formatStr = '';
        this.pos = 0;
        this.token = 'text';
        this.tokenText = '';
    }
    DisplayFormatParser.prototype.start = function (s) {
        this.formatStr = s;
        this.pos = 0;
        this.tokenText = '';
    };
    DisplayFormatParser.prototype.skipSpaces = function () {
        while (this.pos < this.formatStr.length && this.formatStr.charAt(this.pos) === ' ')
            this.pos++;
    };
    DisplayFormatParser.prototype.getToken = function () {
        return this.token;
    };
    DisplayFormatParser.prototype.getTokenText = function () {
        return this.tokenText;
    };
    DisplayFormatParser.prototype.next = function () {
        this.skipSpaces();
        if (this.pos >= this.formatStr.length)
            return false;
        var npos = 0;
        if (this.formatStr.charAt(this.pos) === '{') {
            npos = this.formatStr.indexOf('}', this.pos);
            if (npos < 0)
                return false;
            this.tokenText = this.formatStr.substring(this.pos, npos + 1);
            if (this.tokenText.indexOf('{expr') === 0 || this.tokenText.indexOf('{attr') === 0) {
                this.token = 'expression';
            }
            this.pos = npos + 1;
        }
        else if (this.formatStr.charAt(this.pos) === '[' && this.pos < this.formatStr.length - 1 && this.formatStr.charAt(this.pos + 1) === '[') {
            this.pos += 2;
            npos = this.formatStr.indexOf(']]', this.pos);
            this.token = 'function';
            this.tokenText = this.formatStr.substring(this.pos, npos);
            this.pos = npos + 2;
        }
        else {
            this.token = 'text';
            var npos1 = this.formatStr.indexOf('{', this.pos);
            if (npos1 < 0)
                npos1 = this.formatStr.length;
            var npos2 = this.formatStr.indexOf('[[', this.pos);
            if (npos2 < 0)
                npos2 = this.formatStr.length;
            npos = Math.min(npos1, npos2);
            this.tokenText = this.formatStr.substring(this.pos, npos).trim();
            this.pos = npos;
        }
        return true;
    };
    return DisplayFormatParser;
}());
export { DisplayFormatParser };
//# sourceMappingURL=display_format_parser.js.map